import { Directive, ElementRef, Input, Renderer, OnInit, TemplateRef } from '@angular/core';
import { UUID } from '../uuid';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[gridStackItem]'
})

export class GridStackItemDirective implements OnInit {
    @Input() x: number;
    @Input() y: number;
    @Input() w: number;
    @Input() h: number;
    @Input() minWidth: number;
    @Input() canResize: boolean;
    @Input() id: string;

    constructor(
        private el: ElementRef,
        private renderer: Renderer
    ) {
        renderer.setElementAttribute(el.nativeElement, 'class', 'grid-stack-item');
        this.id = UUID.uuid(10);
    }

    // tslint:disable-next-line:use-life-cycle-interface
    ngOnInit(): void {
        let renderer = this.renderer;
        let nativeElement = this.el.nativeElement;
        let cannotResize: string = this.canResize ? 'yes' : 'no';
 

        renderer.setElementAttribute(nativeElement, 'data-gs-x', String(this.x));
        renderer.setElementAttribute(nativeElement, 'data-gs-y', String(this.y));
        renderer.setElementAttribute(nativeElement, 'data-gs-width', String(this.w));
        renderer.setElementAttribute(nativeElement, 'data-gs-height', String(this.h));
        renderer.setElementAttribute(nativeElement, 'data-gs-id', String(this.id));
        renderer.setElementAttribute(nativeElement, 'id', String(this.id));
        if (this.minWidth) {
            renderer.setElementAttribute(nativeElement, 'data-gs-min-width', String(this.minWidth));
        }
        if (cannotResize === 'yes') {
            renderer.setElementAttribute(nativeElement, 'data-gs-no-resize', cannotResize);
        }

    }
}
